import LogoPasmik from 'assets/icons/PasarMIKRO-Primary-Logogram-3.svg'
import logoCancel from 'assets/icons/topup-cancel.svg'
import CustomButton from 'components/Buttons/CustomButton'
import { useEffect, useState } from 'react'
import { ArrowLeft } from 'react-feather'
import { useLocation, useNavigate } from 'react-router-dom'

const Failed = () => {
  const location = useLocation()
  const dataState = location.state
  const [countdown, setCountdown] = useState(10)
  const navigate = useNavigate()

  useEffect(() => {
    if (dataState?.purpose === 'PAYMENT') {
      const interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1)
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [dataState])

  useEffect(() => {
    if (countdown === 0) {
      navigate(`/public-payment?token=${dataState?.token}`, {
        replace: true,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdown])

  return (
    <div className="flex-centered flex-column" style={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      <div
        className="bg-white p-5 text-center d-flex flex-column align-items-center"
        style={{
          borderRadius: '24px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.05)',
          maxWidth: '400px',
          width: '90%',
        }}
      >
        <img
          style={{ width: '100%', maxWidth: '200px', height: 'auto', marginBottom: '24px' }}
          src={LogoPasmik}
          alt="PasarMIKRO logo"
        />

        <h3
          className="fw-bold text-dark mb-3"
          style={{ fontSize: '20px', marginTop: 20 }}
          data-testid="payment-failed-title"
        >
          Pembayaran Anda telah dibatalkan
        </h3>

        <div
          className="text-secondary mb-4"
          style={{ fontSize: '15px', lineHeight: '1.5' }}
          data-testid="payment-failed-countdown"
        >
          {dataState?.purpose === 'PAYMENT' ? (
            `Anda akan diarahkan untuk memilih pembayaran kembali dalam ${countdown} detik.`
          ) : (
            'Transaksi topup Anda sudah berhasil dibatalkan dan tidak akan diproses lebih lanjut.'
          )}
        </div>

        {dataState?.purpose !== 'PAYMENT' && (
          <CustomButton
            testId="payment-failed-home-button"
            onClick={() => {
              navigate('/', { replace: true })
            }}
            color="primary"
            block
            className="py-3 fw-bold shadow-sm mt-2"
            style={{ borderRadius: '12px', fontSize: '16px' }}
          >
            Kembali ke Beranda
          </CustomButton>
        )}
      </div>
    </div>
  )
}

export default Failed
